import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
const SectionHeader = React.forwardRef(function SectionHeader2({ title, actions, headingLevel = 2, titleId, className, ...rest }, ref) {
  const Heading = headingLevel === 4 ? "h4" : headingLevel === 3 ? "h3" : "h2";
  const hasActions = actions != null && actions !== false;
  return /* @__PURE__ */ jsxs("div", { ref, className: cx("ev-section-header", className), ...rest, children: [
    /* @__PURE__ */ jsx(Heading, { className: "ev-section-title", id: titleId, children: title }),
    hasActions ? /* @__PURE__ */ jsx("div", { className: "ev-section-header__actions", children: actions }) : null
  ] });
});
export {
  SectionHeader
};
//# sourceMappingURL=SectionHeader.js.map
